import { getLiveRate } from './exchangeRates';

export const REGIONS = [
  { code: 'US', name: 'United States', currency: 'USD' },
  { code: 'GB', name: 'United Kingdom', currency: 'GBP' },
  { code: 'CA', name: 'Canada', currency: 'CAD' },
  { code: 'AU', name: 'Australia', currency: 'AUD' },
  { code: 'NG', name: 'Nigeria', currency: 'NGN' },
  { code: 'IN', name: 'India', currency: 'INR' },
  { code: 'DE', name: 'Germany', currency: 'EUR' },
  { code: 'FR', name: 'France', currency: 'EUR' },
  { code: 'JP', name: 'Japan', currency: 'JPY' },
];

export const CURRENCIES = [
  { code: 'USD', symbol: '$', name: 'US Dollar', rate: 1 },
  { code: 'GBP', symbol: '£', name: 'British Pound', rate: 0.79 },
  { code: 'EUR', symbol: '€', name: 'Euro', rate: 0.92 },
  { code: 'NGN', symbol: '₦', name: 'Nigerian Naira', rate: 1550 },
  { code: 'INR', symbol: '₹', name: 'Indian Rupee', rate: 83 },
  { code: 'CAD', symbol: 'C$', name: 'Canadian Dollar', rate: 1.36 },
  { code: 'AUD', symbol: 'A$', name: 'Australian Dollar', rate: 1.52 },
  { code: 'JPY', symbol: '¥', name: 'Japanese Yen', rate: 150 },
];

const STORAGE_KEY = 'Monolith-locale';

export function getCurrency(code) {
  const base = CURRENCIES.find(item => item.code === code) || CURRENCIES[0];
  const live = getLiveRate(base.code);
  if (live != null) {
    return { ...base, rate: live, rateSource: 'live' };
  }
  return { ...base, rateSource: 'static' };
}

export function getRegion(code) {
  return REGIONS.find(item => item.code === code) || REGIONS[0];
}

export function loadStoredLocale() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function saveStoredLocale(locale) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(locale));
  } catch {
    // ignore
  }
}

export function detectRegionFromLocale() {
  const language = (navigator.language || 'en-US').toUpperCase();
  const regionCode = language.split('-')[1];
  if (regionCode && REGIONS.some(r => r.code === regionCode)) {
    return regionCode;
  }
  if (language.startsWith('EN-GB')) return 'GB';
  if (language.startsWith('JA')) return 'JP';
  if (language.startsWith('DE')) return 'DE';
  if (language.startsWith('FR')) return 'FR';
  return 'US';
}

export function formatMoneyAmount(price, currencyCode = 'USD', rateOverride = null) {
  const amount = Number(price);
  if (Number.isNaN(amount)) return price;

  const currency = getCurrency(currencyCode);
  const live = getLiveRate(currency.code);
  const rate =
    rateOverride != null
      ? Number(rateOverride)
      : live != null
        ? live
        : currency.rate;
  const converted = amount * rate;

  if (currency.code === 'JPY' || currency.code === 'NGN') {
    return `${currency.symbol}${Math.round(converted).toLocaleString()}`;
  }

  return `${currency.symbol}${converted.toFixed(2)}`;
}
